var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalShown,
          expression: "modalShown"
        }
      ],
      staticClass: "modal camera-position-modal",
      attrs: { id: "camera-position-modal" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-main" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("dd-loading-modal", { ref: "loadingModalRef" }),
          _vm._v(" "),
          _c("div", { staticClass: "data-area" }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "\n          プラン前面側の選択した位置から中心に向けて撮影します。\n        "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", { staticClass: "label" }, [_vm._v("撮影位置")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.cameraPosition,
                        expression: "cameraPosition"
                      }
                    ],
                    staticClass: "form_contents",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.cameraPosition = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.cameraPositionList, function(position, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: position.code } },
                      [_vm._v(_vm._s(position.label))]
                    )
                  })
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "button-area" }, [
            _c(
              "button",
              {
                staticClass: "main_btn",
                attrs: { type: "button" },
                on: { click: _vm.outputCg }
              },
              [_vm._v("CG出力")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "main_btn",
                attrs: { type: "button" },
                on: { click: _vm.onCancel }
              },
              [_vm._v("キャンセル")]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-area" }, [
      _c("h2", [_vm._v("CG撮影位置設定")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5188afee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5188afee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/output/DcCameraPositionModal.vue
// module id = null
// module chunks = 